/* =========================================================================
   Similar products — one ranking for every product page

   Used by the fashion / default PDP (assets/pdp-fashion.js) and by the
   grooming and health PDPs (assets/vro-pdp-similar.js). Each keeps its own
   markup and chip; this decides WHICH products go in the row.

   What the product is comes from snippets/vro-similar-config.liquid: the
   main menu's kinds and groups it sits in (Tshirts < Topwear, Perfumes <
   Fragrances, Ashwagandha < Ayurveda…), its product type, title, brand and
   tags.

   Where candidates come from, in this order:
     type   Shopify's product-type shelf (/collections/types?q=Jeans)
     kind   the menu kind(s) it sits in whose name matches what it is —
            jeans in Jeans, not also in Rain Jackets where it was filed
            by mistake
     tag    a tag that names what it is ("Duffle Bag", "Analog Watch"),
            for a product the menu has no kind for
     group  the parent group (Bottomwear, Bags & Luggage…) — only if the
            row is still short, and never a group the product sits in by
            mistake (a duffle bag in Footwear)

   Score, per candidate: where it came from (type > kind > tag > group),
   the same product type, words its title shares with this product's, and
   concerns/ingredients shared (grooming, health). A card carrying another
   group's tag than this product's (boots tagged Bottomwear, next to
   jeans) is pushed right down. Test products, duplicate titles and this
   product itself never show.

   A row is the close matches; if there are fewer than four it is topped
   up from what is left with a positive score — never with anything else.
   ========================================================================= */
(function () {
  'use strict';
  if (window.VroSimilar) return;

  var STOP = ['and', 'for', 'men', 'mens', 'man', 'women', 'with', 'the', 'of', 'in', 'on', 'to', 'by',
    'pack', 'set', 'new', 'a', 'an', 'x', 'ml', 'g', 'gm', 'kg', 'l', 'pcs', 'pc', 'piece', 'pieces',
    'size', 'free', 'premium', 'original', 'combo', 'unisex', 'adults', 'adult', 'yes', 'no', 'false', 'true',
    /* Words every product in a department shares, and colours: "fit" and
       "black" make a trouser look like a jacket. */
    'fit', 'black', 'white', 'blue', 'grey', 'gray', 'green', 'red', 'brown', 'navy', 'beige', 'cream', 'olive',
    'pink', 'yellow', 'maroon', 'tan', 'khaki', 'charcoal', 'purple', 'orange', 'multi', 'color', 'colour'];

  /* Tags that say nothing about what a product is: placements, quizzes,
     badges, price bands, seasons, audiences. */
  var JUNK_TAG = /^(placement|vro pick|hype|price drop|whats bugging|3 bros|hyrox mode|health stack|luxe quiz|at |only on|spotlight|new|sale|bestseller|best seller|trending|featured|summer|winter|monsoon|casual|classic|contemporary|minimal|party|street|sporty|weekend|work|everyday|active|false|true|yes|no|men|women|unisex|adults?|kids|rectangle|oval|trapezoid|inverted|test|qa|sample)\b/;

  function norm(s) {
    return String(s || '').toLowerCase().replace(/&/g, ' ').replace(/[^a-z0-9\s-]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function stem(w) {
    w = w.replace(/-/g, '');
    if (w.length > 4 && /ies$/.test(w)) return w.slice(0, -3) + 'y';
    if (w.length > 4 && /(ches|shes|xes|sses)$/.test(w)) return w.slice(0, -2);
    if (w.length > 3 && /s$/.test(w) && !/ss$/.test(w)) return w.slice(0, -1);
    return w;
  }
  function tokens(s, drop) {
    var out = [];
    norm(s).split(' ').forEach(function (w) {
      if (!w || /^\d/.test(w)) return;
      var t = stem(w);
      if (t.length < 2 || STOP.indexOf(t) > -1 || STOP.indexOf(w) > -1) return;
      if (drop && drop.indexOf(t) > -1) return;
      if (out.indexOf(t) === -1) out.push(t);
    });
    return out;
  }
  /* What the product is called, in one word: the last real word of its
     name before any "with", "for", size or dash — "…Nourishing Shampoo",
     "…Baggy Fit Jeans", "…Shaker Bottle with Blender Ball". */
  function headNoun(title, drop) {
    var t = String(title || '').toLowerCase();
    var cut = t.search(/\swith\s|\sfor\s|\s-\s|\s\|\s|\(|,/);
    if (cut > 0) t = t.slice(0, cut);
    /* The form a supplement comes in is not what it is: "Creatine
       Monohydrate Powder" is creatine, "Ashwagandha 60 Capsules" is
       ashwagandha. (Oil, gel, wash and cream stay — in grooming those are
       the kind.) */
    var list = tokens(t, drop).filter(function (w) { return FORMS.indexOf(w) === -1; });
    return list.length ? list[list.length - 1] : '';
  }
  var FORMS = ['powder', 'capsule', 'tablet', 'softgel', 'sachet', 'stick', 'gummy', 'gummie', 'syrup', 'drink', 'granule', 'effervescent', 'unflavoured', 'unflavored', 'flavoured', 'flavored'];

  /* The same product in another size or pack, kept as its own product —
     "…Unflavoured 360g" and "…Unflavoured 120g" — counts once. */
  function sameProductKey(title) {
    return norm(title).split(' ').filter(function (w) {
      return w && !/\d/.test(w) && ['ml', 'g', 'gm', 'kg', 'l', 'pack', 'of', 'pcs', 'x'].indexOf(w) === -1;
    }).join(' ');
  }

  function overlap(a, b) {
    var n = 0;
    a.forEach(function (t) { if (b.indexOf(t) > -1) n++; });
    return n;
  }
  function handleize(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function isTest(card) {
    var tags = '|' + String(card.getAttribute('data-vro-tags') || '').split('|').map(function (t) { return t.trim(); }).join('|') + '|';
    var title = String(card.getAttribute('data-vro-title') || '');
    return tags.indexOf('|test|') > -1 || tags.indexOf('|qa|') > -1 || /^test\b|\btest$/.test(title.trim());
  }

  function load(url) {
    return fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) { return res.ok ? res.text() : ''; })
      .catch(function () { return ''; });
  }
  function parse(html) {
    if (!html) return { cards: [], items: 0 };
    var holder = document.createElement('div');
    holder.innerHTML = html;
    var meta = holder.querySelector('[data-vro-pool]');
    return {
      cards: Array.prototype.slice.call(holder.querySelectorAll('.feed-card')),
      items: meta ? (parseInt(meta.getAttribute('data-vro-items'), 10) || 0) : 0
    };
  }
  function handleOf(card) {
    var h = card.getAttribute('data-vro-handle');
    if (h) return h;
    var a = card.querySelector('a[href*="/products/"]');
    var m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  /* Where to look, from what the product is. */
  function plan(cfg) {
    var vendorToks = tokens(cfg.vendor);
    var type = String(cfg.type || '').trim();
    var me = tokens(type + ' ' + (cfg.title || ''), vendorToks);
    var groupTitles = (cfg.groupTitles || []).map(norm).filter(Boolean);
    var shelves = [];
    var q = '?sort_by=best-selling&view=vro-personalize';

    if (type) {
      shelves.push({ tier: 'type', url: '/collections/types' + q.replace('?', '?q=' + encodeURIComponent(type) + '&'), label: type });
    }

    /* Kinds whose own name is in what this product is called. A typed
       product in no matching kind leans on its type shelf; an untyped one
       with no match keeps its kinds (a perfume called "…EDP" is still in
       Perfumes). */
    var head = headNoun(cfg.title, vendorToks);
    /* The kind that carries its head noun first (Shampoo & Conditioners
       before Hair Loss & Regrowth for a shampoo), then the smaller. */
    var kinds = (cfg.kinds || []).slice().sort(function (a, b) {
      var ha = head && tokens(a.t).indexOf(head) > -1 ? 0 : 1;
      var hb = head && tokens(b.t).indexOf(head) > -1 ? 0 : 1;
      return (ha - hb) || ((a.n || 9999) - (b.n || 9999));
    });
    var matching = kinds.filter(function (k) { return overlap(tokens(k.t), me) > 0; });
    var primary = matching.length ? matching : (type ? [] : kinds);
    primary.slice(0, 3).forEach(function (k) {
      shelves.push({ tier: 'kind', url: '/collections/' + k.h + q, label: k.t, items: k.n, parent: k.p });
    });

    /* A product the menu has no kind for: a tag that names it. */
    if (!primary.length) {
      var used = {};
      (cfg.tags || []).forEach(function (tag) {
        var t = norm(tag);
        if (!t || JUNK_TAG.test(t) || t.indexOf(':') > -1 || /₹|^\d/.test(String(tag))) return;
        if (groupTitles.indexOf(t) > -1) return;
        if (overlap(tokens(t), vendorToks) && tokens(t).length === vendorToks.length) return;
        if (!overlap(tokens(t), me)) return;
        var h = handleize(tag);
        if (used[h] || Object.keys(used).length >= 2) return;
        used[h] = true;
        shelves.push({ tier: 'tag', url: '/collections/all/' + h + q, label: tag });
      });
    }

    /* The group: the parent of a kind it matched, else a group whose name
       is in what it is, else its only group. */
    var groups = cfg.groups || [];
    var parents = primary.map(function (k) { return k.p; });
    var pickGroups = groups.filter(function (g) { return parents.indexOf(g.h) > -1; });
    if (!pickGroups.length) pickGroups = groups.filter(function (g) { return overlap(tokens(g.t), me) > 0; });
    if (!pickGroups.length && groups.length === 1) pickGroups = groups;
    pickGroups.slice(0, 2).forEach(function (g) {
      shelves.push({ tier: 'group', url: '/collections/' + g.h + q, label: g.t, items: g.n });
    });

    /* No group in the menu either (swimming goggles tagged "Sports
       Equipments"): its broadest meaningful tag stands in for one. */
    if (!pickGroups.length && !groups.length) {
      var groupTag = null;
      (cfg.tags || []).forEach(function (tag) {
        var t = norm(tag);
        if (groupTag || !t || JUNK_TAG.test(t) || t.indexOf(':') > -1 || /₹|^\d/.test(String(tag))) return;
        if (overlap(tokens(t), vendorToks) && tokens(t).length === vendorToks.length) return;
        if (shelves.some(function (s) { return s.url.indexOf('/collections/all/' + handleize(tag) + '?') > -1; })) return;
        groupTag = tag;
      });
      if (groupTag) shelves.push({ tier: 'group', url: '/collections/all/' + handleize(groupTag) + q, label: groupTag });
    }

    if (!shelves.length && cfg.fallback) {
      shelves.push({ tier: 'group', url: '/collections/' + cfg.fallback + q.replace('sort_by=best-selling&', ''), label: '' });
    }

    /* The groups this product belongs to by tag, for the conflict check. */
    var myTags = (cfg.tags || []).map(norm);
    var myGroupTags = groupTitles.filter(function (g) { return myTags.indexOf(g) > -1; });
    pickGroups.forEach(function (g) { var t = norm(g.t); if (myGroupTags.indexOf(t) === -1) myGroupTags.push(t); });

    return {
      shelves: shelves, me: me, meTitle: tokens(cfg.title, vendorToks), head: head,
      vendorToks: vendorToks, type: norm(type), groupTitles: groupTitles, myGroupTags: myGroupTags
    };
  }

  /* The product-type shelf and the menu kind weigh the same: a type can
     name two things ("Creatine & BCAA"), so the name decides between them. */
  var TIER = { type: 8, kind: 8, tag: 5, group: 2 };

  function pick(cfg, opts) {
    opts = opts || {};
    var limit = opts.limit || 5;
    var p = plan(cfg);
    var concerns = (opts.concerns || []).filter(function (c) { return c && c.length > 2; });
    var pool = {};
    var order = 0;
    var totals = {};

    /* The first kind shelf counts in full; a second or third kind a
       little less. */
    var firstKind = p.shelves.filter(function (s) { return s.tier === 'kind'; })[0] || null;

    function add(shelf, parsed) {
      totals[shelf.url] = parsed.items;
      var weight = TIER[shelf.tier] * (shelf.tier === 'kind' && shelf !== firstKind ? 0.9 : 1);
      parsed.cards.forEach(function (card) {
        var h = handleOf(card);
        if (!h || h === cfg.handle || isTest(card)) return;
        var c = pool[h];
        if (!c) c = pool[h] = { handle: h, card: card, order: order++, base: 0, shelf: null };
        if (weight > c.base) { c.base = weight; c.shelf = shelf; }
      });
    }

    function score(c) {
      var card = c.card;
      var s = c.base;
      var ctype = norm(card.getAttribute('data-vro-type') || '');
      if (p.type && ctype) {
        if (ctype === p.type) s += 2;
        else s -= 1;
      }
      /* Words its name shares with this one's — the name, not the product
         type, which can name two things ("Creatine & BCAA") — and the
         same head noun counts most: shampoo beside shampoo. */
      var title = String(card.getAttribute('data-vro-title') || '');
      var ctoks = tokens(title, p.vendorToks);
      s += Math.min(4, overlap(ctoks, p.meTitle));
      if (p.head && ctoks.indexOf(p.head) > -1) s += 3;
      var ctags = String(card.getAttribute('data-vro-tags') || '').split('|').map(norm);
      /* Another group's tag this product does not carry: boots tagged
         Bottomwear beside jeans, a shoe tagged Bags beside a duffle. */
      if (p.myGroupTags.length) {
        var foreign = p.groupTitles.filter(function (g) { return ctags.indexOf(g) > -1 && p.myGroupTags.indexOf(g) === -1; });
        if (foreign.length && !ctags.some(function (t) { return p.myGroupTags.indexOf(t) > -1; })) s -= 6;
        else if (foreign.length) s -= 1;
      }
      if (concerns.length) {
        var signals = ((card.getAttribute('data-vro-signals') || '') + ' | ' + (card.getAttribute('data-vro-benefits') || '')).toLowerCase();
        var hits = 0;
        concerns.forEach(function (x) { if (signals.indexOf(x) > -1) hits++; });
        /* A tie-break, not a reason on its own: most supplements share
           "energy" and "recovery". */
        s += Math.min(1.5, hits * 0.5);
      }
      c.score = s;
      c.soldout = card.getAttribute('data-vro-available') === 'false';
      c.title = title;
    }

    function ranked() {
      var all = Object.keys(pool).map(function (h) { return pool[h]; });
      all.forEach(score);
      all.sort(function (a, b) {
        return (b.score - a.score) || ((a.soldout ? 1 : 0) - (b.soldout ? 1 : 0)) || (a.order - b.order);
      });
      var seenTitles = {};
      seenTitles[sameProductKey(cfg.title)] = true;
      return all.filter(function (c) {
        var t = sameProductKey(c.title);
        if (seenTitles[t]) return false;
        seenTitles[t] = true;
        return true;
      });
    }

    function choose(list) {
      var close = list.filter(function (c) { return c.score >= 5; });
      var picked = close.slice(0, limit);
      if (picked.length < Math.min(4, limit)) {
        list.forEach(function (c) {
          if (picked.length >= Math.min(4, limit)) return;
          if (c.score > 0 && picked.indexOf(c) === -1) picked.push(c);
        });
      }
      return { picked: picked, close: close.length };
    }

    var first = p.shelves.filter(function (s) { return s.tier !== 'group'; });
    var later = p.shelves.filter(function (s) { return s.tier === 'group'; });
    if (!first.length) { first = later; later = []; }

    function fetchAll(list) {
      return Promise.all(list.map(function (s) { return load(s.url); })).then(function (pages) {
        pages.forEach(function (html, i) { add(list[i], parse(html)); });
      });
    }

    return fetchAll(first).then(function () {
      var r = choose(ranked());
      if (r.close >= limit || !later.length) return r;
      return fetchAll(later).then(function () { return choose(ranked()); });
    }).then(function (r) {
      /* The shelf the row is from: the first kind (or type, or tag) that
         had cards — its name heads the chip, its size is the "from", and
         "More like this" opens it. */
      /* The row is named after the shelf its first card came from — so a
         lone beard oil topped up from Beardcare says Beardcare, not "Beard
         oil". A product type with others in it names a kind row best
         ("T-Shirts", "Jeans" rather than "Tshirts"). */
      var main = r.picked.length ? r.picked[0].shelf : null;
      var typeShelf = p.shelves.filter(function (s) { return s.tier === 'type'; })[0];
      if (main && main.tier === 'kind' && typeShelf && totals[typeShelf.url] > 1) main = typeShelf;
      var total = 0;
      if (main) total = main.tier === 'kind' || main.tier === 'group' ? (main.items || totals[main.url] || 0) : (totals[main.url] || 0);
      /* "More like this" opens the menu's own page for the kind when there
         is one (/collections/jeans-1), rather than Shopify's automatic
         product-type page. */
      var kindShelf = p.shelves.filter(function (s) { return s.tier === 'kind' && totals[s.url]; })[0];
      var link = main && (main.tier === 'kind' || main.tier === 'type') && kindShelf ? kindShelf : main;
      return {
        cards: r.picked.map(function (c) { c.card.removeAttribute('hidden'); return c.card; }),
        total: Math.max(total, r.close),
        label: main ? main.label : '',
        url: link ? link.url.split('?')[0] + (link.tier === 'type' ? '?q=' + encodeURIComponent(link.label) : '') : '',
        plan: p
      };
    });
  }

  function readConfig(box) {
    var raw = box.getAttribute('data-similar');
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  window.VroSimilar = { pick: pick, plan: plan, readConfig: readConfig, tokens: tokens };
})();
